module.exports = __webpack_public_path__ + "static/media/raum_hirn.2779679d.jpg";